import { jquery } from './jquery.min.js'
import { slick } from './slick.min.js'
import { mask } from './inputmask.min.js'
// import { niceSelect } from './jquery.nice-select.min.js'
import { vacanciesSlider } from './components/vacanciesSlider.js'
import { inputTypeFile } from './components/inputTypeFile'
import { casesSlider } from './components/casesSlider'
import { phoneInputMask } from './components/phoneIinputMask'
import { yandexMap } from './components/yMap'
// import { initNiceSelect } from './components/initNiceSelect'
import phoneMask from './components/phoneMask.js'
import blogImageSlider from './components/blogImageSlider.js'
import { otherArticlesSlider } from './components/otherArticlesSlider.js'
import anchorTransition from './components/anchorTransition.js'
import { mainHeadSlider } from './components/mainPage/mainHeadSlider.js'
import { teamSlider } from './components/mainPage/teamSlider.js'
import { steps } from './components/mainPage/steps.js'
import advantages from './components/mainPage/advantages.js'
import platformSlider from './components/mainPage/platformSlider.js'
import resultsSlider from './components/mainPage/resultsSlider.js'
import tariffs from './components/mainPage/tariffs.js'
import faq from './components/mainPage/faq.js'
import burgerMenu from './components/burgerMenu.js'
import { modal } from './components/modal.js'
import { form } from './components/form.js'
import { review } from './components/review.js'
import { observer } from './components/observer.js'
import { share } from './components/share.js'
import { cases } from './components/cases.js'
import { news } from './components/news.js'
import { reviews } from './components/reviews.js'
import { contacts } from './components/contacts.js'
import { searchPage } from './components/searchPage.js'
import { headerSearch } from './components/headerSearch.js'
import progressSlider from './components/mainPage/progressSlider.js'
import certificateSlider from './components/mainPage/certificateSlider.js'
import ourTeamSlider from './components/mainPage/ourTeamSlider.js'
import promotionSlider from './components/mainPage/promotionSlider.js'
import actionSlider from './components/mainPage/actionSlider.js'
import clientsSlider from './components/mainPage/clientsSlider.js'
import reviewsSlider from './components/mainPage/reviewsSlider.js'
import { toTop } from './components/toTop.js'
import { stages } from './components/stages.js'
import { achievementsSlider } from './components/achievementsSlider.js'
import { otherServicesSlider } from './components/otherServicesSlider.js'
import { calculatorSlider } from './components/calculatorSlider.js'
import { case_06_25 } from './components/case_06_25.js'
import { cookie_usage } from './components/cookie_usage.js'

window.addEventListener('DOMContentLoaded', function () {
	vacanciesSlider();
	casesSlider();
	phoneInputMask();
	yandexMap();
	// initNiceSelect();
	phoneMask();
	blogImageSlider();
	otherArticlesSlider();
	anchorTransition();
	mainHeadSlider();
	teamSlider();
	steps();
	advantages();
	platformSlider();
	resultsSlider();
	tariffs();
	faq();
	burgerMenu();
	modal();
	form();
	review();
    observer();
    share();
    if (document.getElementById('cases')) cases();
    if (document.getElementById('news')) news();
    if (document.getElementById('reviews')) reviews();
    if (document.getElementById('contacts')) contacts();
    searchPage();
    headerSearch();
    progressSlider();
    certificateSlider();
	promotionSlider();
    ourTeamSlider();
    actionSlider();
    clientsSlider();
    reviewsSlider();
    toTop();
    stages();
    achievementsSlider();
    otherServicesSlider();
	calculatorSlider();
	case_06_25();
	cookie_usage();
});
